import type { AuthPort } from '../ports/auth_port'
import { ApiError } from '@/core/http/response_error'
import type { Credential } from '@/features/signin/domains/credential'
import type { ResponseResult } from '@/core/http/response-result'
import type { AuthUserToken } from '../../domains/auth_user_token'

export class LoginUseCase {
  private authPort: AuthPort

  constructor(authPort: AuthPort) {
    this.authPort = authPort
  }

  async execute(payload: Credential): Promise<ResponseResult<AuthUserToken>> {
    try {
      const result = await this.authPort.login(payload)
      return result
    } catch (error) {
      const _error: ApiError = error as ApiError
      return {
        STATUS_CODE: 2,
        ERROR: _error,
      }
    }
  }
}
